const initialState = {
  isOpen: false,
  isSubmitting: false,
  action: undefined,
}

const setIsSubmitting = (state, isSubmitting) => ({
  ...state,
  isSubmitting
})

const setIsOpen = (state, isOpen, action) => ({
  ...state,
  isOpen,
  action,
})

const startSubmitting = (state) => setIsSubmitting(state, true)
const stopSubmitting = (state) => setIsSubmitting(state, false)
const openPopup = (state, action) => setIsOpen(state, true, action)
const closePopup = (state) => setIsOpen(state, false)

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'INTEGRATIONS_DISCONNECT_POPUP_OPEN':
      return openPopup(state, payload.action)
    case 'INTEGRATIONS_DISCONNECT_POPUP_CLOSE':
      return closePopup(state)
    case 'INTEGRATIONS_DISCONNECT_POPUP_START_SUBMITTING':
      return startSubmitting(state)
    case 'INTEGRATIONS_DISCONNECT_POPUP_STOP_SUBMITTING':
      return stopSubmitting(state)
    default:
      return state
  }
}
